import axios from 'axios';
import { clearNotification } from '../../store/action/notifications';
import { setAuthToken } from '../../store/action/userInfo';

const BASE_URL = process.env.REACT_APP_API_URL;
const BASE_URL_V2 = process.env.REACT_APP_API_URL_V2;

export let appDispatch = null;

export const setAxiosDispatch = (dispatch) => {
	appDispatch = dispatch;
};

const getUserSubdomainFromUrl = () => {
	const match = window.location.pathname.match(/^\/user\/([^/]+)/);
	return match ? match[1] : null;
};

const handleAuthFailure = () => {
	if (appDispatch) {
		appDispatch(clearNotification());
		appDispatch(setAuthToken({ authToken: null }));
	}
	localStorage.clear();
	const subdomain = getUserSubdomainFromUrl();
	if (subdomain) {
		window.location.replace(`/user/${subdomain}`);
	} else {
		window.location.replace('/');
	}
};

const axiosInstance = axios.create({
	baseURL: BASE_URL,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
		'Cache-Control': 'no-store',
	},
});

export const axiosInstanceV2 = axios.create({
	baseURL: BASE_URL_V2,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
		'Cache-Control': 'no-store',
	},
});

const responseInterceptor = (instance) => {
	instance.interceptors.response.use(
		(response) => response,
		(error) => {
			const status = error?.response?.status;
			if (status === 401 || status === 403) {
				handleAuthFailure();
			}
			return Promise.reject(error);
		},
	);
};

responseInterceptor(axiosInstance);
responseInterceptor(axiosInstanceV2);

export default axiosInstance;
